/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Perk_AppInputs */

const en_portal_perk_app = /** @type {(inputs: Portal_Perk_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App for iOS and Android`)
};

const pl_portal_perk_app = /** @type {(inputs: Portal_Perk_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacja na iOS i Androida`)
};

/**
* | output |
* | --- |
* | "App for iOS and Android" |
*
* @param {Portal_Perk_AppInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_perk_app = /** @type {((inputs?: Portal_Perk_AppInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Perk_AppInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_perk_app(inputs)
	return en_portal_perk_app(inputs)
});